/**
 * Report unexpected API/client contract deviations.
 * Always logs via the shared logger (which writes to console when not silent).
 * Callers still do best-effort recovery after reporting.
 */

import { log } from '@/lib/utils/logger';

/**
 * Logs a contract/shape deviation. Keeps running after the call — callers still do best-effort recovery.
 */
export function reportApiContractDeviation(message: string, details?: unknown): void {
  log.error(`[API contract] ${message}`, details);
}
